const scheduledServicesCalendarHeader = {
  title: "Scheduled Services Calendar",
  filters: "Filters",
  clear: "Clear",
};

export default scheduledServicesCalendarHeader;
